import { useCallback, useEffect, useState } from "react";
import { supabase } from "@/lib/supabase";

export interface AuditLog {
  id: number;
  user_id: string | null;
  actor_name: string | null;
  action: string;
  detail: string | null;
  level: string;
  created_at: string;
  batch_id: string | null;
}

interface UseAuditLogsResult {
  logs: AuditLog[];
  loading: boolean;
  error: string | null;
  reload: () => void;
}

export function useAuditLogs(): UseAuditLogsResult {
  const [logs, setLogs] = useState<AuditLog[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const { data, error: queryError } = await supabase
        .from("activity_logs")
        .select("*")
        .order("created_at", { ascending: false })
        .limit(500);
      if (queryError) throw queryError;
      setLogs((data as AuditLog[]) ?? []);
    } catch (err) {
      setError(err instanceof Error ? err.message : "操作日志加载失败，请稍后重试");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void load();
  }, [load]);

  return { logs, loading, error, reload: load };
}